import EmailModal from "app/components/EmailModal/EmailModal";

export default EmailModal;